import { Moment } from 'moment';
import { QuestResponseType } from '../Quotation/Quotation.types';

export enum StockAbcCurveReportType {
  part = 'Part',
  service = 'Service',
  customer = 'Customer',
}

export enum StockAbcCurveOrderBy {
  quantity = 'Quantity',
  value = 'Value',
}

export interface QuestReportStockAbcCurveRequest {
  responseType: QuestResponseType;
  companiesIds?: string;
  reportType: StockAbcCurveReportType;
  orderBy: StockAbcCurveOrderBy;
  startDate: string;
  endDate: string;
  groupIds?: string;
}

export interface QuestReportStockAbcCurveFormValues {
  companiesIds?: number[];
  reportType: StockAbcCurveReportType;
  orderBy: StockAbcCurveOrderBy;
  initialDate: Moment;
  finalDate: Moment;
  groupIds?: number[];
}
